// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 441 ? "b9da0acd" : chunkId) + "." + {"441":"6e09992adf9326ad","651":"ac427794328e2841"}[chunkId] + ".js";
};